declare const __SITE_HTTPS_PORT__: string | undefined;

const PORT = typeof __SITE_HTTPS_PORT__ === 'string' ? __SITE_HTTPS_PORT__ : '';

/** A site's public address, with the port when sites are not served on 443. */
export function siteUrl(domain: string, path = '/'): string {
  return `https://${domain}${PORT && PORT !== '443' ? `:${PORT}` : ''}${path}`;
}
